module.exports = __webpack_public_path__ + "fedex.svg?6d34edbf5c5b2a522b9d6aac034332d6";